"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var types_1 = require("./types");
function defer() {
    var resolve, reject;
    var promise = new Promise(function (_resolve, _reject) {
        resolve = _resolve;
        reject = _reject;
    });
    return { promise: promise, resolve: resolve, reject: reject };
}
var locationFuncOrValue = function (locationProp) {
    return typeof locationProp === 'function' ? locationProp() : locationProp;
};
var serializeResult = function (results) { return (tslib_1.__assign({}, results, { geometry: {
        location: {
            lat: locationFuncOrValue(results.geometry.location.lat),
            lng: locationFuncOrValue(results.geometry.location.lng),
        },
    } })); };
// placeDetails is not required at the moment
var GoogleMapsBasicClient = /** @class */ (function () {
    function GoogleMapsBasicClient() {
    }
    GoogleMapsBasicClient.prototype._initServices = function () {
        if (!this._autocomplete) {
            this._autocomplete = new window.google.maps.places.AutocompleteService();
        }
        if (!this._geocoder) {
            this._geocoder = new window.google.maps.Geocoder();
        }
    };
    GoogleMapsBasicClient.prototype.loadScript = function (clientId, lang) {
        var _this = this;
        if (this._loadScriptPromise) {
            return this._loadScriptPromise;
        }
        if (window.google && window.google.maps) {
            this._initServices();
            return;
        }
        var _a = defer(), promise = _a.promise, resolve = _a.resolve;
        window.initMap = function () {
            _this._initServices();
            resolve();
        };
        var script = document.createElement('script');
        var authKey = this._useClientId ? 'client' : 'key';
        script.src = "//maps.googleapis.com/maps/api/js?libraries=places&" + authKey + "=" + clientId + "&callback=initMap&language=" + lang;
        document.body.appendChild(script);
        this._loadScriptPromise = promise;
        return promise;
    };
    GoogleMapsBasicClient.prototype.useClientId = function () {
        this._useClientId = true;
    };
    GoogleMapsBasicClient.prototype.autocomplete = function (clientId, lang, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, promise, resolve, reject;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = defer(), promise = _a.promise, resolve = _a.resolve, reject = _a.reject;
                        return [4 /*yield*/, this.loadScript(clientId, lang)];
                    case 1:
                        _b.sent();
                        this._autocomplete.getPlacePredictions(typeof request === 'string' ? { input: request } : request, function (results, status) {
                            if (status === types_1.PlacesServiceStatusTypes.Ok) {
                                resolve(results);
                            }
                            else {
                                reject(status);
                            }
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    GoogleMapsBasicClient.prototype.geocode = function (clientId, lang, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, promise, resolve, reject;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = defer(), promise = _a.promise, resolve = _a.resolve, reject = _a.reject;
                        return [4 /*yield*/, this.loadScript(clientId, lang)];
                    case 1:
                        _b.sent();
                        this._geocoder.geocode(typeof request === 'string' ? { address: request } : request, function (results, status) {
                            if (status === types_1.PlacesServiceStatusTypes.Ok) {
                                resolve(results.map(function (result) { return serializeResult(result); }));
                            }
                            else {
                                reject(status);
                            }
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    return GoogleMapsBasicClient;
}());
exports.GoogleMapsBasicClient = GoogleMapsBasicClient;
//# sourceMappingURL=GoogleMapsBasicClient.js.map